import { render, staticRenderFns } from "./AccountsPayable.vue?vue&type=template&id=5c0fde1a&"
import script from "./AccountsPayable.vue?vue&type=script&lang=js&"
export * from "./AccountsPayable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports